<mat-drawer-container [hasBackdrop]="tabletQuery.matches" class="page-height">
  <mat-drawer
    #drawer
    [mode]="tabletQuery.matches ? 'over' : 'side'"
    [position]="'end'"
    [opened]="!tabletQuery.matches"
    [disableClose]="!tabletQuery.matches"
  >
    <odin-dev-mode-chooser />
    <!-- Actions in sidenav -->
    @if (transactionFilters$ | async; as transactionFilters) {
      <div class="h-100">
        <odin-transactions-filters-form
          [transactionFiltersInitial]="transactionFilters"
          (transactionFiltersChanged)="filterTransactions($event)"
          (csvReport)="csvReportsDownload($event)"
        >
        </odin-transactions-filters-form>
      </div>
    }
  </mat-drawer>
  <mat-drawer-content
    class="ml-0 bg-panel page-height d-flex justify-content-between align-items-center flex-column p-md-2"
  >
    <!-- Transaction list header -->
    <mat-divider></mat-divider>
    <div
      class="d-flex justify-content-between align-items-center flex-row py-3 px-4 w-100 list-toolbar main-panel rounded-top"
      style="z-index: 10"
    >
      <button
        mat-icon-button
        class="bg-white-always mon-border-primary border mon-text-primary d-flex align-items-center justify-content-center"
        (click)="refreshTransactions()"
        data-test="transactions-refresh-btn"
      >
        <mat-icon
          class="d-block overflow-visible"
          style="width: 24px; height: 24px"
          >refresh</mat-icon
        >
      </button>

      <div class="flex-fill" style="min-width: 0">
        @if (fuzzySearchEnabled()) {
          <odin-search-bar
            [inputValue]="(searchInputValue$ | async) || ''"
            [inputPlaceholder]="searchControlPlaceholder"
            (outputValue)="searchTransactions($event)"
          >
          </odin-search-bar>
        }
      </div>

      <button
        class=""
        mat-icon-button
        class="bg-white-always mon-border-primary border mon-text-primary d-flex align-items-center justify-content-center"
        (click)="drawer.open()"
        [disabled]="!tabletQuery.matches"
        data-test="transactions-filters-btn"
      >
        <mat-icon
          class="d-block overflow-visible"
          style="width: 24px; height: 24px"
          >filter_alt</mat-icon
        >
      </button>
    </div>

    <!-- Transaction list -->
    <div class="flex-fill w-100 overflow-hidden">
      @if (error$ | async; as error) {
        <div class="odin-empty-state odin-empty-state-error error-transactions main-panel h-100" data-test="transactions-error">
          <div class="odin-empty-state-icon">
            <mat-icon class="outline">error_outline</mat-icon>
          </div>
          <p class="odin-empty-state-title">Unable to load transactions</p>
          <p class="odin-empty-state-text">
            {{ errorText('Something went wrong while fetching your transactions. Please try again.', error) }}
          </p>
          <div class="odin-empty-state-actions">
            <button mat-stroked-button class="mon-text-primary mon-border-primary" (click)="refreshTransactions()">
              <mat-icon>refresh</mat-icon>
              Retry
            </button>
          </div>
        </div>
      } @else {
        @if (transactions$ | async; as transactions) {
          <div class="h-100" @fadeAnimation>
            <odin-transactions-list
                class="d-block h-100"
                [refresh]="refreshEvent"
                [transactions]="transactions"
                [allowSelection]="allowSelection$ | async"
                [hasNext]="hasNext$ | async"
                [hasPrev]="hasPrev$ | async"
                [loading]="loading$ | async"
                (scrollDirection)="loadTransactionsOnScroll($event)"
              >
                @if (noMoreToLoad$ | async) {
                  <div class="odin-list-end" data-test="transactions-list-end">
                    <mat-icon class="outline">check_circle</mat-icon>
                    <span>End of transactions</span>
                  </div>
                }
                @if (transactions.length === 0 && (loading$ | async) === false) {
                  <div class="odin-empty-state" data-test="transactions-empty">
                    <div class="odin-empty-state-icon">
                      <mat-icon class="outline">receipt_long</mat-icon>
                    </div>
                    <p class="odin-empty-state-title">No transactions found</p>
                    <p class="odin-empty-state-text">
                      There are no transactions matching your current search and
                      filters. Try widening the date range or clearing a filter.
                    </p>
                  </div>
                }
              </odin-transactions-list>
            @if (transactions.length > 0 && (loading$ | async)) {
              <odin-loading-spinner
                class="mt-2"
                [active]="true"
                [diameter]="40"
                [colour]="colour"
              ></odin-loading-spinner>
            }
          </div>
        }
      }
    </div>
  </mat-drawer-content>
</mat-drawer-container>

<!-- Outside the drawer container so the fixed overlay isn't trapped in its
     stacking context (the filters drawer would otherwise cover it) -->
<odin-new-experience-banner></odin-new-experience-banner>
